import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { EMPTY_STRING } from "../../constants/global.constants";
import { homeActions } from "../../redux/actions";
import { SliderNext, SliderPrev } from "../../assets";
import { SLIDE_DIRECTION } from "../../constants";

const CountryBanner = (props) => {
  const {
    allAllowedCountries,
    getAllAllowedCountries,
    setFilters,
    filters,
  } = props;

  const [countries, setCountries] = useState([]);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const scrollRef = useRef(null);

  const updateCountriesFilter = (id) => {
    setFilters((prev) => ({
      ...prev,
      countryIds: prev.countryIds.includes(id)
        ? prev.countryIds.filter((cId) => cId !== id)
        : [...prev.countryIds, id],
    }));
  };

  const updateScrollVisibility = () => {
    setTimeout(() => {
      if (scrollRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
        setCanScrollPrev(scrollLeft > 0);
        setCanScrollNext(scrollLeft < scrollWidth - clientWidth - 1);
      }
    }, 100);
  };

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === SLIDE_DIRECTION.NEXT ? 300 : -300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    getAllAllowedCountries();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (allAllowedCountries.length > 0) {
      setCountries(allAllowedCountries);
      updateScrollVisibility();
    }
  }, [allAllowedCountries]);

  useEffect(() => {
    const currentScrollRef = scrollRef.current;
    if (currentScrollRef) {
      currentScrollRef.addEventListener("scroll", updateScrollVisibility);
      return () => {
        currentScrollRef.removeEventListener("scroll", updateScrollVisibility);
      };
    }
  }, [scrollRef]);

  return (
    <div className="container mx-auto country-banner-container position-relative px-4">
      <div
        className={`country-banner-prev-icon-container d-flex align-items-center justify-content-center pointer ${
          canScrollPrev ? "visible" : "invisible"
        }`}
        onClick={() => handleScroll(SLIDE_DIRECTION.PREVIOUS)}
      >
        <img src={SliderPrev} alt="Prev" />
      </div>
      <div
        className={`country-banner-next-icon-container d-flex align-items-center justify-content-center pointer ${
          canScrollNext ? "visible" : "invisible"
        }`}
        onClick={() => handleScroll(SLIDE_DIRECTION.NEXT)}
      >
        <img src={SliderNext} alt="Next" />
      </div>
      <div className="country-banner-centered">
        <div className="country-banner" ref={scrollRef}>
          <ul className="list-inline d-flex">
            {countries.map((c) => (
              <li
                className={`list-inline-item px-2 ${
                  filters.countryIds.includes(c.id)
                    ? "active-country"
                    : EMPTY_STRING
                }`}
                key={c.id}
                onClick={() => updateCountriesFilter(c.id)}
              >
                {c.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allAllowedCountries: state.homeReducer.allAllowedCountries,
});

const mapDispatchToProps = (dispatch) => ({
  getAllAllowedCountries: () => dispatch(homeActions.getAllAllowedCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CountryBanner);
